import axios from "axios";
import {url} from "../../../crudRequests";

export async function uploadFile(state, path, file, toast, onSuccess) {
  const formData = new FormData();
  formData.append("file", file);
  const tenantDb = state.db || state.organization?.db || "";
  
  try {
    const response = await axios({
      method: "POST",
      url: `${url}/crudStorageUpload`,
      headers: {
        "X-Tenant": tenantDb,
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + state.jwt,
      },
      data: formData,
      params: {
        id: state.patient?.pid || state.doctor?.did || state.admin?.id,
        db: tenantDb,
        directoryName: path,
        locationId: state.selectedLocation,
        s3BucketName: state.organization?.s3BucketName || "brightlighthealth",
      },
    });
    
    if (onSuccess) {
      onSuccess(response.data);
    }
    
    return response.data;
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }
}